module.exports = __webpack_public_path__ + "static/img/copy_url_preview.0bd9626b.png";